let ajaxCalcAccess = true;
var arr_timers_form_input = [];
var arr_timers_form_textarea = [];
var submitError = false;
function createError(item) {
    create_timer(item);
    item.closest('label').addClass("error");
    item.closest('label').find(".error_text").fadeIn(250);
};
function create_timer(item) {
    let type = item[0].tagName;
    let index = $("form input").index(item);
    let mass = (type == 'INPUT') ? arr_timers_form_input[index] : arr_timers_form_textarea[index];
    clearTimeout(mass);
    arr_timers_form_input[index] = setTimeout(function () {
        item.parent().removeClass("error");
        item.parent().find(".error_text").fadeOut(300);
    }, 5000);
};

function scrollToErrorInput() {
    let inputTop, scrollTop;
    if ($(this).closest(".popup_block").length) {
        inputTop = $(this).closest("label").position().top;
        scrollTop = $(".popup_block:visible .popupContent").scrollTop();
        if (inputTop < scrollTop + $("header").innerHeight() || inputTop > scrollTop + window.innerHeight) {
            scrollTo('.popup_block:visible .popupContent', inputTop, 0.5)
        }
    } else {
        inputTop = $(this).closest("label").offset().top;
        scrollTop = $(window).scrollTop();
        if (inputTop < scrollTop + $("header").innerHeight() || inputTop > scrollTop + window.innerHeight) {
            scrollTo('body, html', inputTop - $("header").innerHeight() - 50)
        }
    }
};

function validatePassword() {
    const inputs = this.find("input[type='password']");
    let password;
    let mismatch = false;
    let minLengthError = false;
    let minLength = 6;

    inputs.each(function () {
        const val = $(this).val();
        if (val.length < minLength && val.length > 0) {
            minLengthError = true
            errorDo.call($(this), '6 characters minimum')
        };
        if (typeof password == 'undefined') {
            password = val;
            return true;
        }
        if (password != val) {
            mismatch = true;
            errorDo.call($(this), 'Password mismatch')
        }
    });
    if (mismatch && !minLengthError) {
        inputs.each(function () {
            errorDo.call($(this), 'Password mismatch')
        });
    };
    return (minLengthError || mismatch);
};

function errorDo(text) {
    $(this).nextAll(".error_text").remove();
    $(this).after('<span class="error_text">' + text + '</span>');
    if (!submitError) scrollToErrorInput.call($(this));
    submitError = true;
    createError($(this));
}

$(document).ready(function () {
    $(".authorizationForm input[name='checkbox']").change(function () {
        const checked = $(this).prop("checked");
        $(this).closest("form").find("button[type=submit]")[!checked ? 'addClass' : 'removeClass']('disabled');
    });
    $(".authorizationForm").submit(function (e) {
        e.preventDefault();
        var thise = $(this);
        var form = $(this);
        submitError = false;
        form.find(".error").removeClass("error");
        form.find(".error_text").remove();

        let inputList = form.find("input").not(".forgotPassword input");
        if (form.hasClass("forgotPasswordNow")) { // forgotPassword
            inputList = form.find(".forgotPassword input");
        };
        inputList.each(function () {
            if ($(this).val() == "" && $(this).prop('required')) {
                errorDo.call($(this), 'Required')
            };
            // tel
            
            if ($(this).attr("type") == "tel") {
                if ($(this).val().length < 14) {
                    if ($(this).val().length) {
                        errorDo.call($(this), 'Required')
                    } else {
                        errorDo.call($(this), 'Syntax error')
                    }
                };
            };
            
            // tel my
            if ($(this).hasClass("phone-valid") && $(this).prop('required')) {
                var phone_val = $(this).val();
                var test_phone= /^(\+)?(\(\d{2,3}\) ?\d|\d)(([ \-]?\d)|( ?\(\d{2,3}\) ?)){5,12}\d$/;
                if (!phone_val || !test_phone.test(phone_val)) {
                    if (phone_val.length) {
                        errorDo.call($(this), 'Incorrect format')
                    } else {
                        errorDo.call($(this), 'Required')
                    }
                };
            };
            //tel my2
            if ($(this).hasClass("phone-valid")) {
                var phone_val = $(this).val();
                var test_phone= /^(\+)?(\(\d{2,3}\) ?\d|\d)(([ \-]?\d)|( ?\(\d{2,3}\) ?)){5,12}\d$/;
                if (!phone_val || !test_phone.test(phone_val)) {
                    if (phone_val.length) {
                        errorDo.call($(this), 'Incorrect format')
                    }
                };
            };


            


            // checkbox
            if ($(this).attr("type") == "checkbox" && $(this).prop('required')) {
                if (!$(this).prop('checked')) {
                    errorDo.call($(this), '')
                }
            }
            // email
            if ($(this).attr("type") == "email" && $(this).prop('required')) {
                var email_val = $(this).val();
                var test_email = /^([a-zA-Z0-9_.-])+@([a-zA-Z0-9_.-])+\.([a-zA-Z])+([a-zA-Z])+/;
                if (!email_val || !test_email.test(email_val)) {
                    if (email_val.length) {
                        errorDo.call($(this), 'Incorrect email address')
                    } else {
                        errorDo.call($(this), 'Required')
                    }
                };
            };
            // email not-required
            if ($(this).attr("type") == "email") {
                var email_val = $(this).val();
                var test_email = /^([a-zA-Z0-9_.-])+@([a-zA-Z0-9_.-])+\.([a-zA-Z])+([a-zA-Z])+/;
                if (!email_val || !test_email.test(email_val)) {
                    if (email_val.length) {
                        errorDo.call($(this), 'Incorrect email address')
                    }
                };
            };
        });
        form.find("textarea").each(function () {
            if ($(this).val() == "" && $(this).prop('required')) {
                errorDo.call($(this), 'Required')
            };
        });

        form.find("select").each(function () {
            if ( ($(this).val() == "" || $(this).val() == null ) && $(this).prop('required')) {
                errorDo.call($(this), 'Required')
            };
        });
        // validate password
        let passError = false;
        if (form.closest(".popup_block").hasClass("registerPopup")) {
            passError = validatePassword.call(form);
        }
        if (!submitError && !passError) {
            let event = undefined;
            if (form.closest(".popup_block").hasClass("loginPopup")) {
                event = 'login';
            };
            if (form.closest(".popup_block").hasClass("registerPopup")) {
                event = 'registration';
            };
            if (form.closest(".registerPopup").hasClass("loginPopup")) {
                // not valid ?
                event = 'registration';
            };
            if (form.hasClass("forgotPasswordNow")) {
                event = 'forgotPassword';
            };
            if (form.hasClass("form-add-listing")) {
                const type = form.data('type');
                event = 'form-add-listing-'+ type;
            };
            let data = form.serialize() + '&event=' + event;
            successForm(data, event, form);
        }
        return false;
    });
});

function forgotPassword() {
    const form = $(".authorizationForm .forgotPassword").closest("form");
    const content = form.find(".forgotPasswordContent");
    form.toggleClass("forgotPasswordNow");
    if (form.hasClass("forgotPasswordNow")) {
        content.slideDown(animTime);
    } else {
        content.slideUp(animTime);
    };
};

function resetForm(form) {
    form.find("label.hover").removeClass('hover');
    form.trigger('reset');
};